import { Component, OnInit } from '@angular/core';
import { BaseDataService, ModelData } from 'yt-ng-framework';
import { PoreskoOslobodjenje } from 'src/app/lookups/poresko-oslobodjenje/poresko-oslobodjenje';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-spisak-poreskih-oslobodjenja',
  templateUrl: './spisak-poreskih-oslobodjenja.component.html'
})
export class SpisakPoreskihOslobodjenjaComponent implements OnInit {

  constructor(
    protected baseDataService: BaseDataService,
    protected activeModal: NgbActiveModal,
  ) { }

  items = [];
  Config={};
  modelData: ModelData;

  ngOnInit() {
    this.baseDataService.Get('PoreskoOslobodjenje','get',null,PoreskoOslobodjenje)
    .subscribe(data => {
      this.items = data;
      this.Config={
        EditIcon: {
          Visible: false
        },
        DeleteIcon: {
          Visible: false
        },
        DefaultSortKey: this.modelData.MainList.SortBy,
        DefaultSortReverse: this.modelData.MainList.SortReverse,
        ShowIndex: false,
        ShowDefaultListButtons: false,
        ShowCheckBoxes: true,
        PrintIcon: {
          Visible: false
        }
        ,BreadCrumble: this.modelData.BreadcrumbLabel
      }
    });
  }
  
  async Save(){
    let odabrani: string = "";
    if (this.items){
      for(const item of this.items){
        await new Promise<void>((resolve, reject) =>{
         if (item.Checked){
          odabrani = (odabrani + "\r" + item.Naziv).trim();
         }
         resolve();
        })
      }
    }
   

  
    this.activeModal.close(odabrani);
  }

  Close(){
    this.activeModal.dismiss();
  }

}
